module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_6005.b5fc03d9.png";